export default __webpack_public_path__ + "svgs/welt-777f8757.svg";